import {
  createProgressiveRequestHandler,
  createRequestHandler,
} from "../utils/requestHandlers";

import { cfAPI } from "../api";
import { createFormData } from "../utils/onCreateFormData";
import { createProgressHandler } from "../utils/createProgressHandler"; // Assuming this utility exists

// Import reusable handlers

// Action Types
const BLOG_REQUEST = "BLOG_REQUEST";
const BLOG_ERROR = "BLOG_ERROR";
const BLOGS_FETCH = "BLOGS_FETCH";
const BLOG_FETCH = "BLOG_FETCH";
const BLOG_CREATE = "BLOG_CREATE";
const BLOG_EDIT = "BLOG_EDIT";
const BLOG_DELETE = "BLOG_DELETE";

// Download Action Types for blogs
const BLOG_DOWNLOAD_START = "BLOG_DOWNLOAD_START";
const BLOG_DOWNLOAD_UPDATE = "BLOG_DOWNLOAD_UPDATE";
const BLOG_DOWNLOAD_FINISH = "BLOG_DOWNLOAD_FINISH";

const BaseRoute = "cfwebapi/api/v1/blogs";

// Reusable action types object for consistency
const actionTypes = {
  fetches: { request: BLOG_REQUEST, success: BLOGS_FETCH, error: BLOG_ERROR },
  fetch: { request: BLOG_REQUEST, success: BLOG_FETCH, error: BLOG_ERROR },
  create: { request: BLOG_REQUEST, success: BLOG_CREATE, error: BLOG_ERROR },
  update: { request: BLOG_REQUEST, success: BLOG_EDIT, error: BLOG_ERROR },
  delete: { request: BLOG_REQUEST, success: BLOG_DELETE, error: BLOG_ERROR },
  download: {
    request: BLOG_REQUEST,
    start: BLOG_DOWNLOAD_START,
    update: BLOG_DOWNLOAD_UPDATE,
    finish: BLOG_DOWNLOAD_FINISH,
    success: BLOGS_FETCH,
    error: BLOG_ERROR,
  },
};

const INITIAL_STATE = {
  loading: false,
  blogs: [],
  blog: {},
  error: "",
  downloadProgress: 0,
  isDownloading: false,
};

// Actions using the new handlers

export const FetchBlogs = () => async (dispatch) => {
  await createProgressiveRequestHandler(
    dispatch,
    () =>
      cfAPI.get(BaseRoute, {
        onDownloadProgress: createProgressHandler(
          dispatch,
          actionTypes.download.update,
          actionTypes.download.finish
        ),
      }),
    actionTypes.download,
    createProgressHandler
  );
};

export const FetchBlog = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(`${BaseRoute}/${id}`),
    actionTypes.fetch,
    null // No toast for a fetch
  );
};

export const CreateBlog = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, createFormData(values)),
    actionTypes.create,
    "Blog Created"
  );
};

export const UpdateBlog = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${id}`, createFormData(values)),
    actionTypes.update,
    "Blog Updated"
  );
};

export const DeleteBlog = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${values.id}`),
    actionTypes.delete,
    "Blog Deleted"
  );
};

// Reducer with toasts removed and state logic updated
export const BlogReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BLOG_DOWNLOAD_START:
      return { ...state, isDownloading: true, downloadProgress: 0 };
    case BLOG_DOWNLOAD_UPDATE:
      return { ...state, downloadProgress: action.payload };
    case BLOG_DOWNLOAD_FINISH:
      return { ...state, isDownloading: false, downloadProgress: 100 };
    case BLOG_REQUEST:
      return { ...state, loading: true };
    case BLOGS_FETCH:
      return { ...state, loading: false, error: "", blogs: action.payload };
    case BLOG_FETCH:
      return { ...state, loading: false, error: "", blog: action.payload };
    case BLOG_CREATE:
      return {
        ...state,
        loading: false,
        error: "",
        blogs: [...state.blogs, action.payload],
      };
    case BLOG_EDIT:
      const updatedList = state.blogs.map((blog) =>
        blog.id === action.payload.id ? action.payload : blog
      );
      return {
        ...state,
        loading: false,
        error: "",
        blog: action.payload,
        blogs: updatedList,
      };
    case BLOG_DELETE:
      const newList = state.blogs.filter((s) => s.id !== action.payload.id);
      return {
        ...state,
        loading: false,
        error: "",
        blogs: newList,
      };
    case BLOG_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
